<template>
  <div>
      <!-- Header -->
	   <b-modal v-model="modalShow" ok-only centered class="text-center text-info">
    	  You are not logged in as a user or your email is not verified!
    	</b-modal>
		 <b-modal v-model="modalShow1" ok-only centered class="text-center text-info">
    	  You can't add more shops to My SHOPiN!
    	</b-modal>
		 <b-modal v-model="modalShow2" ok-only centered class="text-center text-info">
    	  Shop is added to My SHOPiN.
    	</b-modal>
	<header class="header-v4">
		<!-- Header desktop -->
		<div class="container-menu-desktop">
			<!-- Topbar -->
			<div class="top-bar">
				<div class="content-topbar flex-sb-m h-full container">
					<div class="left-top-bar">
						<router-link v-if="name!= ''" class="logo px-2" to="/" style="font-size:18px; border:2px solid red;background-color:#580000; color:#fff; text-transform:uppercase;" >{{name}}
    <!-- <img src='../../../static/img/eshops-round1.png' alt="eshops-logo"> -->
  
  </router-link>
						 
						<!-- Free shipping for standard order over $100 -->
					</div>

					<div class="right-top-bar flex-w h-full">
					
						<router-link style="color:red;" :to="{name: 'admin'}" v-if="admin" class="flex-c-m trans-04 p-lr-25">
							Admin Area
						</router-link>
						<router-link style="color:red;" :to="{name: 'admin-services'}" v-if="pageadmin" class="flex-c-m trans-04 p-lr-25">
							Admin Area
						</router-link>
						<router-link :to="{name: 'signin'}" v-if="visitor" class="flex-c-m trans-04 p-lr-25">
							Sign in
						</router-link>
						
						<router-link :to="{name: 'usersignup'}" v-if="visitor" class="flex-c-m trans-04 p-lr-25">
							Sign up
						</router-link>
						<router-link :to="{name: 'storecart'}" v-if="user" class="flex-c-m trans-04 p-lr-25">
							View Cart
						</router-link>
						<a style="cursor:pointer; color:red;" @click="logout()" v-if="user || admin || pageadmin" class="flex-c-m trans-04 p-lr-25">Sign out</a>


						
					</div>
				</div>
			</div>

			<div class="wrap-menu-desktop how-shadow1">
				<nav class="limiter-menu-desktop container">
					
					<!-- Logo desktop -->		
					<!-- <a href="#" class="logo">
						<img src="images/icons/logo-01.png" alt="IMG-LOGO">
					</a> -->

					<!-- Menu desktop -->
					<div class="menu-desktop">
						<ul class="main-menu">
							<li>
								<router-link :to="{name: 'storehome'}">Home</router-link>
								
							</li>

							<!-- <li>
								<a>Products</a>
								<ul class="sub-menu">
									<li v-for="(hh, category) in categoriesList" :key="category"><router-link  :to="{name: 'storeproducts', query: {cat: category}}">{{category}}</router-link></li>
									
								</ul>
							</li> -->

							<li v-if="plan != 'Starter'">
							<router-link  :to="{name: 'storecategories'}">Categories</router-link>
							</li>

							<li v-if="plan == 'Starter'">
							<router-link  :to="{name: 'storeitems'}">Products</router-link>
							</li>

							<li>
							<router-link :to="{name: 'storeoffers'}">Offers</router-link>
							
							</li>

							<li>
								<router-link :to="{name: 'storeabout'}">About</router-link>
							</li>

							<li>
								<router-link :to="{name: 'storecontact'}">Contact</router-link>
							</li>

						</ul>
					</div>	

					<!-- Icon header -->
					<div class="wrap-icon-header flex-w flex-r-m">
						<!-- <div class="icon-header-item cl2 hov-cl1 trans-04 tooltip100" :data-tooltip="this.datanotify">
							<i class="fa fa-heart-o" v-if="(isFavShop == undefined || isFavShop == 'show')" @click="addToFavourite()"></i>
							<i class="fa fa-heart-o text-danger" v-if="(isFavShop == this.$route.params.storename)" style="cursor:default;" ></i>
						</div> -->
						<!-- <div class="icon-header-item cl2 hov-cl1 trans-04 p-l-22 p-r-11 icon-header-noti" :data-notify="visits"  style="cursor:default;">
							<i class="zmdi zmdi-eye"></i>
						</div> -->
						<div class="icon-header-item cl2 hov-cl1 trans-04 p-r-11 p-l-10 icon-header-noti" :data-notify="cartItems" v-if="plan == 'Premium' || plan ==  'Enterprise'">
							<i class="fa fa-shopping-cart" @click="cartClicked()"></i>
							<!-- <router-link :to="{name: 'storecart', params:{storename: this.$route.params.storename}}"  v-if="cartlink"></router-link> -->
						</div>
						

					</div>
				</nav>
			</div>	
		</div>

		<!-- Header Mobile -->
		<div class="wrap-header-mobile" style="position:fixed; z-index: 1099; width:100%;">
			<!-- Logo moblie -->		
			<div class="logo-mobile  mt-2">
				<router-link v-if="name!= ''" class="ml-2 px-2" to="/" style="font-size:18px; border:2px solid red;background-color:#180000; color:#fff; text-transform:uppercase;" >{{name}}
    <!-- <img src='../../../static/img/eshops-round1.png' alt="eshops-logo"> -->
  
  </router-link>
			</div>

			<!-- Icon header -->
			<div class="wrap-icon-header flex-w flex-r-m" style="">
				<!-- <div class="icon-header-item cl2 hov-cl1 trans-04">
						<i class="fa fa-heart-o" v-if="(isFavShop == undefined || isFavShop == 'show')" @click="addToFavourite()" style="font-size:25px;"></i>
							<i class="fa fa-heart-o text-danger" v-if="(isFavShop == this.$route.params.storename)" style="cursor:default; font-size:25px;" ></i>
				</div> -->
				<!-- <div class="dis-block icon-header-item cl2 hov-cl1 trans-04 p-r-11 p-l-10 icon-header-noti" :data-notify="visits">
					<i class="zmdi zmdi-eye"></i>
				</div> -->
				<div class="icon-header-item cl2 hov-cl1 trans-04 p-r-11 p-l-10 icon-header-noti" :data-notify="cartItems" v-if="plan == 'Premium' || plan ==  'Enterprise'">
					<i class="fa fa-shopping-cart" style="font-size:30px;" @click="cartClicked()"></i>
				</div>
	
			</div>

			<!-- Button show menu -->
			<div class="btn-show-menu-mobile hamburger js-show-cart text-white"style="color:#fff;">
				<span class="hamburger-box text-white" style="color:#fff;">
					<i class="fa fa-bars hamburger-inner text-white" style="color:#fff!important;"></i>
				</span>
			</div>
		</div>


		<!-- Menu Mobile -->
		<div class="wrap-header-cart js-panel-cart" >
		<div class="s-full js-hide-cart"></div>

		<!-- <div class="header-cart flex-col-l p-l-65 p-r-25">
		
			<ul class="topbar-mobile">
				<li>
					<div class="left-top-bar">
						Free shipping for standard order over $100
					</div>
				</li>

				<li>
					<div class="right-top-bar flex-w h-full">
						<a href="#" class="flex-c-m p-lr-10 trans-04">
							Help & FAQs
						</a>

						<a href="#" class="flex-c-m p-lr-10 trans-04">
							My Account
						</a>

						<a href="#" class="flex-c-m p-lr-10 trans-04">
							EN
						</a>

						<a href="#" class="flex-c-m p-lr-10 trans-04">
							USD
						</a>
					</div>
				</li>
			</ul>

			<ul class="main-menu-m">
				<li>
					<a href="product.html">Home</a>
				</li>

				<li>
					<router-link :to="{name: 'search', query: {cat: cat, loc: loc}}">Search</router-link>
				</li>

				<li>
					<a>Products</a>
					<ul class="sub-menu-m">
									<li v-for="(hh, category) in categoriesList" :key="category"><router-link  :to="{name: 'storeproducts', query: {cat: category}}">{{category}}</router-link></li>
									
								</ul>
					<span class="arrow-main-menu-m">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</span>
				</li>

				<li>
					<a href="shoping-cart.html" class="label1 rs1" data-label1="hot">Features</a>
				</li>

				<li>
					<router-link :to="{name: 'storecategories', params:{storename: this.$route.params.storename}}">Categories</router-link>
				</li>

				<li>
					<a href="about.html">About</a>
				</li>

				<li>
					<a href="contact.html">Contact</a>
				</li>
			</ul>
		
		</div> -->
		</div>
		<!-- Modal Search -->
		<!-- <div class="modal-search-header flex-c-m trans-04 js-hide-modal-search">
			<div class="container-search-header">
				<button class="flex-c-m btn-hide-modal-search trans-04 js-hide-modal-search">
					<img src="images/icons/icon-close2.png" alt="CLOSE">
				</button>

				<form class="wrap-search-header flex-w p-l-15">
					<button class="flex-c-m trans-04">
						<i class="zmdi zmdi-search"></i>
					</button>
					<input class="plh3" type="text" name="search" placeholder="Search...">
				</form>
			</div>
		</div> -->
	</header>

	<!-- Cart -->
	<div class="wrap-header-cart js-panel-cart">
		<div class="s-full js-hide-cart"></div>

		<div class="header-cart " >
			<div class="header-cart-title flex-w flex-sb-m p-b-8">
				<div class="logo-mobile mt-4">
					<router-link class="px-2" to="/" style="font-size:18px; border:2px solid red;background-color:#180000; color:#fff; text-transform:uppercase;" >{{name}}
  					</router-link>
				</div>

				<div class="fs-35 lh-10 cl2 p-lr-5 pointer hov-cl1 trans-04 js-hide-cart">
					<i class="fa fa-close"></i>
				</div>
			</div>
			
			<div class="header-cart-content  js-pscroll m-slide-h" style="height: 440px;">
				<ul class="main-menu-m ">

									<li>
				<router-link :to="{name: 'storehome'}">Store Home</router-link>
				</li>
				

				<li v-if="plan != 'Starter'">
					<router-link  :to="{name: 'storecategories'}">Store Categories</router-link>
				</li>

				<li v-if="plan == 'Starter'">
					<router-link  :to="{name: 'storeitems'}">Store Products</router-link>
				</li>

				<li>
					<router-link :to="{name: 'storeoffers'}">Store Offers</router-link>
					
				</li>

				<li>
					<router-link :to="{name: 'storeabout'}">Store About</router-link>
				</li>

				<li>
					<router-link :to="{name: 'storecontact'}">Store Contact</router-link>
				</li>
				<hr>
					
					<li><router-link :to="{name: 'admin'}" v-if="admin" class="">
							Admin Area
						</router-link>
					</li>
					<li><router-link :to="{name: 'admin-services'}" v-if="pageadmin" class="">
							Admin Area
						</router-link>
					</li>
					<li>
						<router-link :to="{name: 'signin'}" v-if="visitor">
							Sign in
						</router-link>
					</li>
					<li>
						<router-link :to="{name: 'usersignup'}" v-if="visitor">
							Sign up
						</router-link>
					</li>
					<li>
						<router-link :to="{name: 'storecart'}" v-if="user">
							View Cart
						</router-link>
					</li>
					<li>
						<a style="cursor:pointer;" @click="logout()" v-if="user || admin ||pageadmin">
							Sign out
						</a>
					</li> 
					

			</ul>
				<!-- <ul class="header-cart-wrapitem w-full">
					<li class="header-cart-item flex-w flex-t m-b-12">
						<div class="header-cart-item-img">
							<img src="images/item-cart-01.jpg" alt="IMG">
						</div>

						<div class="header-cart-item-txt p-t-8">
							<a href="#" class="header-cart-item-name m-b-18 hov-cl1 trans-04">
								White Shirt Pleat
							</a>

							<span class="header-cart-item-info">
								1 x $19.00
							</span>
						</div>
					</li>

					<li class="header-cart-item flex-w flex-t m-b-12">
						<div class="header-cart-item-img">
							<img src="images/item-cart-02.jpg" alt="IMG">
						</div>

						<div class="header-cart-item-txt p-t-8">
							<a href="#" class="header-cart-item-name m-b-18 hov-cl1 trans-04">
								Converse All Star
							</a>

							<span class="header-cart-item-info">
								1 x $39.00
							</span>
						</div>
					</li>

					<li class="header-cart-item flex-w flex-t m-b-12">
						<div class="header-cart-item-img">
							<img src="images/item-cart-03.jpg" alt="IMG">
						</div>

						<div class="header-cart-item-txt p-t-8">
							<a href="#" class="header-cart-item-name m-b-18 hov-cl1 trans-04">
								Nixon Porter Leather
							</a>

							<span class="header-cart-item-info">
								1 x $17.00
							</span>
						</div>
					</li>
				</ul>
				
				<div class="w-full">
					<div class="header-cart-total w-full p-tb-40">
						Total: $75.00
					</div>

					<div class="header-cart-buttons flex-w w-full">
						<router-link :to="{name: 'storecart', params:{storename: this.$route.params.storename}}" class="flex-c-m stext-101 cl0 size-107 bg3 bor2 hov-btn3 p-lr-15 trans-04 m-r-8 m-b-10">
							View Cart
						</router-link>

						<a href="shoping-cart.html" class="flex-c-m stext-101 cl0 size-107 bg3 bor2 hov-btn3 p-lr-15 trans-04 m-b-10">
							Check Out
						</a>
					</div>
				</div> -->
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from "firebase/app"
import 'firebase/auth'
import {bus} from "../../main"
require('../../assets/store/vendor/jquery/jquery-3.2.1.min.js')
import '../../assets/store/vendor/animsition/js/animsition.min.js'
import mobiles from '../../data/mobiles'
import ClothingAccessories from '../../data/ClothingAccessories'

export default {
  name: 'navbar',
  data() {
	  return {
		  modalShow: false,
		  modalShow1:false,
		  modalShow2:false,
		  categoriesList: [],
		  shops: [],
		  favshops:[],
		  isFavShop:'show',
		  isLoggedIn: false,
		  visits:'',
		  name:'',
		  loc:'',
		  cat:'',
		  param:'',
		  searchQuery:{},
		  plan:'',
		  cartItems:0,
		  user: false,
		  admin:false,
		  pageadmin:false,
		  visitor: false,
		  datanotify:'Add to My SHOPiN',
		  shopcats:{}

	  }
  },
 // props: ['categoriesList'],
  watch: {
      
      shops () {
         if(this.shops[0].shoptype == 'Fashion'){
          this.categoriesList = ClothingAccessories
      }
      if(this.shops[0].shoptype == 'Elec'){
          this.categoriesList = mobiles
      }
      }
  },
	methods: {
		addToFavourite(){
			if(!firebase.auth().currentUser){
				this.modalShow = true
			}
			if(firebase.auth().currentUser && firebase.auth().currentUser.emailVerified){
				// if(firebase.auth().currentUser.displayName == 'shop owner'){
				// 	this.modalShow = true
				// }else{
					if(this.favshops[0].favshops.length <= 25){
					this.favshops[0].favshops.push(this.$route.params.storename)
					console.log('favsp updated', this.favshops[0].favshops)
					this.isFavShop = this.$route.params.storename
					this.modalShow2 = true
					db.collection('users').doc(this.favshops[0].docid)
					.update({
					favshops: this.favshops[0].favshops
					})
					.then(() => console.log(''))
					.catch(error => console.log('error',error))
					}else{
						this.modalShow1 = true
					}
				//}
			}else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){
				this.modalShow = true
			}
			
			},

		logout () {
          firebase.auth().signOut()
          .then( () => {
              this.$router.push('/')
          })
      },
	  cartClicked(){
		  if(this.visitor){
			  this.modalShow = true
		  }else if(this.user || this.admin || this.pageadmin){
			  this.cartlink = true
			  this.$router.push({name: 'storecart'})
		  }
	  }
	},
	created(){
		
		bus.$on('cartChanged', (data) => {
			this.cartItems = data
		})

		if(firebase.auth().currentUser){
        if(firebase.auth().currentUser.displayName == null){
          this.user = true
        }else if(firebase.auth().currentUser.displayName == 'shop owner' || firebase.auth().currentUser.displayName == 'starterplan shop owner'){
			this.admin = true
		}else if(firebase.auth().currentUser.displayName == 'page owner'){
			this.pageadmin = true
		}
      }else{
        this.visitor = true
      }
		// if(firebase.auth().currentUser){
		// if(firebase.auth().currentUser.displayName != 'shop owner'){
		// 	this.isLoggedIn = true
		// }
		// }
		 console.log("this.shops[0].shoptype")
		 if(this.$store.state.shops[0] != undefined){
				 this.shopcats = this.$store.state.shops[0].categories
				this.visits = this.$store.state.shops[0].visits
				this.name = this.$store.state.shops[0].name
				// this.loc = this.shops[0].loc
				this.cat = this.$store.state.shops[0].cat
				this.plan = this.$store.state.shops[0].plan
				console.log('cat is', this.cat)
				console.log('this.$store.state.shops[0] is', this.$store.state.shops[0])
				
				this.loc = this.$store.state.searchLocation
				
				this.searchQuery['cat'] = this.cat
				this.searchQuery['loc'] = this.loc
		}else{
			db.collection('shops')
			.onSnapshot(querySnapshot => {
			querySnapshot.forEach(doc => {
				const data = {
				'name' : doc.data().name,
				'shoptype' : doc.data().shoptype,
				'visits': doc.data().visits,
				'loc': doc.data().location,
				'categories':doc.data().categories,
				'plan':doc.data().plan,
				'cat': doc.data().cat,
				'details': doc.data().details,  
			
			}
			this.shops.push(data)
			console.log(this.shops[0].shoptype)
			this.name = this.shops[0].name
			this.shopcats = this.shops[0].categories
			this.visits = this.shops[0].visits
			// this.loc = this.shops[0].loc
			this.cat = this.shops[0].cat
			this.plan = this.shops[0].plan
			console.log('cat is', this.cat)
			console.log('cat is', this.shops[0].cat)
			this.$store.state.shops[0] = this.shops[0]
			console.log('cat is', this.$store.state.shops[0])
			this.loc = this.$store.state.searchLocation
			
			this.searchQuery['cat'] = this.cat
			this.searchQuery['loc'] = this.loc
		})
		})
	}
//   beforeCreate(){
	  
	if(firebase.auth().currentUser){
		// if(firebase.auth().currentUser.displayName != 'shop owner'){
		// db.collection('users').where('uid', '==', firebase.auth().currentUser.uid).get()
		// .then(querySnapshot => {
		// querySnapshot.forEach(doc => {
		// 	const data = {
		// 	'favshops' : doc.data().favshops,
		// 	'docid': doc.id
		// 	}
		// 	this.favshops.push(data)
		// 	console.log('favshops',this.favshops)
		// })
		// var findFavShop = function(fshops, id){
		// 	var findedid = fshops.find((fs, index) => {
		// 		return fs == id
		// 	})
		// 	return findedid
		// }
		// this.isFavShop = findFavShop(this.favshops[0].favshops, this.$route.params.storename)
		// console.log('isFavShop',this.isFavShop)
		// if(this.isFavShop == this.$route.params.storename){
		// 	this.datanotify = 'Added to My SHOPiN'
		// }
		// })
		
			console.log('cartitems',this.$store.state.cartItems)
			if(this.$store.state.cartItems != undefined){
				this.cartItems = this.$store.state.cartItems
				console.log('Store cartItems',this.cartItems)
			}else{
			var cartitems = []
			var foreachRun = false
			db.collection('carts').where('uid', '==', firebase.auth().currentUser.uid)
			.get()
			.then(querySnapshot => {
			querySnapshot.forEach(doc => {
			const data = {
			}
			foreachRun = true
			cartitems.push(data)
			console.log('cartitems',cartitems)
			this.cartItems = cartitems.length
			this.$store.state.cartItems = cartitems.length
			console.log('this.cartItems',this.cartItems)
		})
			console.log('cartitems',cartitems)
			if(foreachRun == false){
				this.$store.state.cartItems = 0
			}
		})
		}
		

		
	}
  },
  
}
</script>

<style scoped>
    @import url('~@/assets/store/css/main.css');
    @import url('~@/assets/store/css/util.css');
    /* @import url('~@/assets/store/fonts/font-awesome-4.7.0/css/font-awesome.min.css'); */
    /* @import url('~@/assets/store/fonts/iconic/css/material-design-iconic-font.min.css'); */
    /* @import url('~@/assets/store/fonts/linearicons-v1.0.0/icon-font.min.css'); */
    @import url('~@/assets/store/vendor/animate/animate.css');
     @import url('~@/assets/store/vendor/css-hamburgers/hamburgers.min.css');
	 @import url('~@/assets/store/vendor/animsition/css/animsition.min.css');
	 
	  @media (max-height: 400px) {
		 .m-slide-h{
			 height: 230px;
		 }
	 }
	 @media (max-height: 500px) {
		 .m-slide-h{
			 height: 340px;
		 }
	 }
</style>



// WEBPACK FOOTER //
// src/components/store/StoreNavbar.vue